import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

// Mutation for upserting travelers.
const UPSERT_TRAVELERS_MUTATION = gql`
  mutation travelersUpsert($input: [TravelerInput!]!) {
    travelersUpsert(input: $input) {
      travelers {
        id
        name
        email
        phone
      }
    }
  }
`

export interface Traveler {
  id?: string
  name: string
  email: string
  phone: string
}

interface UpsertTravelersData {
  travelers: Traveler[]
}

interface TravelersUpsertMutationResponse {
  travelersUpsert: UpsertTravelersData
}

export const useTravelersUpsertApi = (): UseMutationResult<
  UpsertTravelersData,
  Error,
  Traveler[],
  unknown
> => {
  const client = useGraphQLClient()

  const upsertTravelersApi = async (travelers: Traveler[]): Promise<UpsertTravelersData> => {
    if (!travelers?.length) return { travelers: [] }

    const input = travelers.map(({ id, name, email, phone }) => ({
      // Pass id only if defined.
      ...(id && { id }),
      name,
      email,
      phone,
    }))
    const result = await client.request<TravelersUpsertMutationResponse>(
      UPSERT_TRAVELERS_MUTATION,
      {
        input,
      },
    )
    return result.travelersUpsert
  }

  return useMutation<UpsertTravelersData, Error, Traveler[]>({ mutationFn: upsertTravelersApi })
}
